declare const jQuery: any;
const $ = jQuery;

export function initPostsPage(): void {
    initPostsPageCatNav();
}

function initPostsPageCatNav(): void {
    const $nav = $(`.hs-post-page-cat-nav`);
    if ($nav.length === 0) {
        return;
    }
    const $items = $nav.find(`[data-cat]`);
    const $containers = $(`[data-cat-posts]`);
    $items.on("click", function (event) {
        $items.removeClass("selected");
        const id = $(this).addClass("selected").attr("data-cat");
        $containers.removeClass("selected").filter(`[data-cat-posts="${id}"]`).addClass("selected");
        return false;
    });
}
